import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface CalendarListHeaderProps {
  isAllSelected: boolean
  onToggle: (event: React.MouseEvent<HTMLElement>) => void
}

export const CalendarListHeader: React.FC<CalendarListHeaderProps> = ({ isAllSelected, onToggle }) => {
  const { t } = useTranslation()

  return (
    <>
      <Box
        component="button"
        onClick={onToggle}
        aria-label={(isAllSelected ? t('Deselect all') : t('Select all')) as string}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          width: '100%',
          px: 2,
          py: 1,
          border: 'none',
          background: 'none',
          cursor: 'pointer',
          borderRadius: 1,
          transition: 'background-color 0.15s',
          '&:hover': { backgroundColor: 'action.hover' },
        }}
      >
        {/* Checkbox — filled when all selected, empty otherwise */}
        <Box
          sx={{
            width: 14,
            height: 14,
            borderRadius: '3px',
            border: '1.5px solid',
            borderColor: isAllSelected ? 'text.secondary' : 'rgba(0,0,0,0.3)',
            backgroundColor: isAllSelected ? 'text.secondary' : 'transparent',
            flexShrink: 0,
            transition: 'all 0.2s ease',
          }}
        />
        <Typography
          variant="body2"
          sx={{
            fontSize: '0.8rem',
            fontWeight: 400,
            color: 'text.secondary',
            letterSpacing: '0.01em',
            userSelect: 'none',
          }}
        >
          {isAllSelected ? t('Deselect all') : t('Select all')}
        </Typography>
      </Box>
      <Divider sx={{ mx: 2, mb: 0.5 }} />
    </>
  )
}

export default CalendarListHeader
